<template>
  <table class="w-full table-fixed">
      <tbody>
        <tr v-for="item in products" :key="item.code">
          <td class="px-3 py-1 border-b border-gray-300">
            <strong class="text-sm">{{ item.label }}</strong>
            <span class="ml-1 text-xs text-gray-600">{{ item.fromDB.product_categories[0].title }}</span>
          </td>
          <td class="w-32 px-3 py-1 text-right border-b border-gray-300">
            <span class="ml-1 mr-1 text-xs text-gray-600 whitespace-no-wrap"
              >Art.-Nr.</span
            >{{ item.code }}
          </td>
        </tr>
      </tbody>
    </table>
</template>

<script>
export default {
  props: ['products']
};
</script>

<style scoped lang="postcss">
table tbody tr:last-child td {
  @apply border-none;
}
</style>
